import { useCallback, useMemo } from "react";
import { message } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import hljs from "highlight.js";
import "highlight.js/styles/github.css";
import styles from "../index.module.scss";

const copyToClipboard = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
    message.success("复制成功，内容由AI生成");
  } catch (err) {
    // 降级方案
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
    message.success("复制成功，内容由AI生成");
  }
};

const CodeBlock = ({ children, className, node, ...props }: any) => {
  const match = /language-(\w+)/.exec(className || "");
  const language = match ? match[1] : "";
  const codeString = String(children).replace(/\n$/, "");

  const handleCopy = useCallback(() => {
    copyToClipboard(codeString);
  }, [codeString]);

  // 使用highlight.js进行语法高亮
  const highlightedCode = useMemo(() => {
    if (language && hljs.getLanguage(language)) {
      return hljs.highlight(codeString, { language }).value;
    }
    return hljs.highlightAuto(codeString).value;
  }, [codeString, language]);

  if (!match) {
    return (
      <code className={styles.inlineCode} {...props}>
        {children}
      </code>
    );
  }

  return (
    <div className={styles.codeBlock}>
      <div className={styles.codeHeader}>
        <span className={styles.language}>{language || "text"}</span>
        <button
          className={styles.copyButton}
          onClick={handleCopy}
          type="button"
        >
          {/* @ts-ignore */}
          <CopyOutlined />
        </button>
      </div>
      <pre className={styles.codeContent}>
        <code
          className={`hljs language-${language}`}
          dangerouslySetInnerHTML={{ __html: highlightedCode }}
        />
      </pre>
    </div>
  );
};

export default CodeBlock;
